import { call, put, take } from 'redux-saga/effects'
import api from '../api/api'
import { isResponseSuccessful, statusCodeIsBelow400 } from '../helpers/utility'

import {
  PROFILE_UPDATE_SUCCESS,
  MANAGER_TOGGLE_USER_VERIFICATION_REQUEST,
  MANAGER_TOGGLE_USER_VERIFICATION_FAIL,
  MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_END,
  MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_START,
} from '../actions/actions'

import {
  ADD_STUDENT_TO_SCHOOL_REQUEST,
  ADD_STUDENT_TO_SCHOOL_SUCCESS,
  ADD_STUDENT_TO_SCHOOL_FAIL,
  ADD_STUDENT_TO_SCHOOL_ASYNC_START,
  ADD_STUDENT_TO_SCHOOL_ASYNC_END,
} from '../actions/actions'

import {
  ADD_STUDENT_TO_SUPERVISOR_REQUEST,
  ADD_STUDENT_TO_SUPERVISOR_SUCCESS,
  ADD_STUDENT_TO_SUPERVISOR_FAIL,
  ADD_STUDENT_TO_SUPERVISOR_ASYNC_END,
  ADD_STUDENT_TO_SUPERVISOR_ASYNC_START,
} from '../actions/actions'

import {
  FETCH_SERVICE_STATS_REQUEST,
  FETCH_SERVICE_STATS_SUCCESS,
  FETCH_SERVICE_STATS_FAIL,
  FETCH_SERVICE_STATS_ASYNC_START,
  FETCH_SERVICE_STATS_ASYNC_END,
} from '../actions/actions'

export function* changeUserVerificationStatus() {
  while (true) {
    const { formData, userType, userId, resolve, reject } = yield take(
      MANAGER_TOGGLE_USER_VERIFICATION_REQUEST
    )

    yield put({ type: MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_START })

    const lowerCaseUserType = userType.toLowerCase()
    const upperCaseUserType = userType.toUpperCase()

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.changeUserVerificationStatus, userType, userId, formData)

      if (statusCodeIsBelow400(status)) {
        // this will be used by profile reducer:
        yield put({
          type: PROFILE_UPDATE_SUCCESS,
          userInfo: data[lowerCaseUserType],
        })

        // this will be used by the userType-based reducer:
        yield put({
          type: `MANAGER_TOGGLE_${upperCaseUserType}_VERIFICATION_SUCCESS`,
          [lowerCaseUserType]: data[lowerCaseUserType],
        })

        resolve && resolve()
      } else {
        yield put({
          type: MANAGER_TOGGLE_USER_VERIFICATION_FAIL,
          general_errors,
        })

        reject && reject({ form_errors, general_errors })
      }
      yield put({ type: MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_END })
    } catch (error) {
      yield put({ type: MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_END })
      yield put({ type: MANAGER_TOGGLE_USER_VERIFICATION_FAIL, error })
      console.log(error)
    }
  }
}

export function* addStudentToSchool() {
  while (true) {
    const { formData, schoolId, resolve, reject } = yield take(
      ADD_STUDENT_TO_SCHOOL_REQUEST
    )

    yield put({ type: ADD_STUDENT_TO_SCHOOL_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.addStudentsToSchool, formData, schoolId)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: ADD_STUDENT_TO_SCHOOL_SUCCESS,
          students: data.students,
        })

        resolve(data.students)
      } else {
        yield put({
          type: ADD_STUDENT_TO_SCHOOL_FAIL,
        })

        reject([...form_errors.students]) // only thing that can go wrong is students
      }

      yield put({ type: ADD_STUDENT_TO_SCHOOL_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: ADD_STUDENT_TO_SCHOOL_ASYNC_END })
      yield put({ type: ADD_STUDENT_TO_SCHOOL_FAIL, error })
      console.log(error)
    }
  }
}

export function* addStudentToSupervisor() {
  while (true) {
    const { formData, supervisorId, resolve, reject } = yield take(
      ADD_STUDENT_TO_SUPERVISOR_REQUEST
    )

    yield put({ type: ADD_STUDENT_TO_SUPERVISOR_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.addStudentsToSupervisor, formData, supervisorId)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: ADD_STUDENT_TO_SUPERVISOR_SUCCESS,
          students: data.students,
        })

        resolve(data.students)
      } else {
        yield put({
          type: ADD_STUDENT_TO_SUPERVISOR_FAIL,
        })

        reject([...form_errors.students]) // only thing that can go wrong is students
      }
      yield put({ type: ADD_STUDENT_TO_SUPERVISOR_ASYNC_END })
    } catch (error) {
      reject()
      console.log(error)
      yield put({ type: ADD_STUDENT_TO_SUPERVISOR_ASYNC_END })
      yield put({ type: ADD_STUDENT_TO_SUPERVISOR_FAIL, error })
    }
  }
}

export function* fetchServiceStats() {
  while (true) {
    const { serviceId, resolve, reject } = yield take(FETCH_SERVICE_STATS_REQUEST)
    yield put({ type: FETCH_SERVICE_STATS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.getStatsOfService, serviceId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SERVICE_STATS_SUCCESS,
          students: data.stats,
        })

        resolve(data.stats)
      } else {
        yield put({
          type: FETCH_SERVICE_STATS_FAIL,
          errors,
        })

        reject(errors)
      }
      yield put({ type: FETCH_SERVICE_STATS_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: FETCH_SERVICE_STATS_ASYNC_END })
      yield put({ type: FETCH_SERVICE_STATS_FAIL, error })
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/managersSaga.js